import { tokens } from '@sparkpost/design-tokens';
import React, { useCallback } from 'react';
import { ActiveFilters } from 'src/components';
import { Box, Button, Modal, Stack, Tag, Text } from 'src/components/matchbox';
import { TranslatableText } from 'src/components/text';
import { snakeToFriendly } from 'src/helpers/string';

export default function DeleteAlertModal({ open, onClose, alert = {} }) {
  const deleteAlert = useCallback(() => {
    // TODO: Implement api request
  }, []);

  return (
    <Modal open={open} onClose={onClose}>
      <Modal.Header showCloseButton>Delete Alert</Modal.Header>
      <Modal.Content>
        <Stack>
          <Box>
            Deleting the alert is permanent. The respective metric and criteria will no longer be
            tracked and all historical incident history will be deleted.
          </Box>
          <Box>
            <Text as="b">Alert Name</Text>
            <Text>{alert.name}</Text>
          </Box>
          <Box>
            <Text as="b">Alert Summary</Text>
            <Text as="i">
              <Box display="flex" flexWrap="wrap" alignItems="center" whiteSpace="pre-wrap">
                <TranslatableText>The alert is triggered when </TranslatableText>
                <Tag>{snakeToFriendly(alert.metric)}</Tag>
                ( <ActiveFilters filters={alert.filters} /> )
                <TranslatableText> is </TranslatableText>
                <Tag>{alert.condition}</Tag> <Tag>{alert.threshold_evaluator.value}%</Tag>
                <TranslatableText> at the end of a </TranslatableText>
                <Tag>1 {alert.precision}</Tag> period.
              </Box>
            </Text>
          </Box>
        </Stack>
      </Modal.Content>
      <Modal.Footer>
        <Button variant="destructive" color="red" onClick={deleteAlert}>
          Delete Alert
        </Button>
        <Button onClick={onClose} variant="monochrome-secondary" color={tokens.color_gray_900}>
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
